import React, { useEffect, useState } from 'react'
import { useAppSelector } from '@/app/hooks'
import { AppDispatch } from '@/app/store'
import { CheckInPaymentForm } from '@/components/organisms/check-in-payment-form'
import { Layout } from '@/components/template/layout'
import { spacerTopStyle } from '@/styles/common'
import { useDispatch } from 'react-redux'
import { clearPayments, deleteCheckInPaymentData, getCheckInPayments } from '@/features/checkIn/check-in-payment-slice'
import { useQuerySearchParams } from '@/hooks/use-query-search-params'
import { AmountBill, RoomBillDetail } from '@/components/organisms/room-bill-detail'
import { useNavigate } from 'react-router-dom'
import { Loading } from '@/components/organisms/loading'
import { getSessionCheckInData } from '@/features/checkIn/check-in-slice'
import { PaymentFormTemplate } from '@/components/template/payment-form-template'
import { CheckInStep, CheckInStepName } from '@/components/organisms/checkIn/check-in-step'
import { ContentWrapper } from '@/components/template/content-wrapper'

export const CheckInPayment: React.FC = () => {
  const searchParams = useQuerySearchParams<{ hotelId: string }>()
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const [totalAmount, setTotalAmount] = useState(0)
  const [totalTax, setTotalTax] = useState(0)
  const [isFetchedComponentData, setIsFetchedComponentData] = useState(false)

  const { payments, loading } = useAppSelector(state => state.checkIn.checkInPayments)
  const { assignSpaces } = useAppSelector(state => state.timeSelection)

  const loadPayments = async () => {
    const checkInData = getSessionCheckInData()
    try {
      if (!checkInData?.reservationIds) {
        return navigate('/checkin-reservation-confirm', { replace: true })
      }

      const loadPayments = await dispatch(
        getCheckInPayments({ hotelId: searchParams.hotelId, reservationIds: checkInData.reservationIds }),
      ).unwrap()
      const totalTimeSelectionPrice = assignSpaces?.reduce((carry, space) => carry + (space.price || 0), 0)
      const totalTimeSelectionTax = assignSpaces?.reduce((carry, space) => carry + (space.tax || 0), 0)
      if ((loadPayments?.totalAmount || 0) + totalTimeSelectionPrice <= 0) {
        dispatch(deleteCheckInPaymentData())
        dispatch(clearPayments())
        return navigate({ pathname: '/checkin-confirm' }, { replace: true })
      }
      setTotalAmount(loadPayments.totalAmount + totalTimeSelectionPrice)
      setTotalTax(loadPayments.totalTaxPrice + totalTimeSelectionTax)
    } catch (error) {
      navigate({ pathname: '/checkin' }, { replace: true })
    }
  }

  useEffect(() => {
    loadPayments().then(() => setIsFetchedComponentData(true))
  }, [])

  return (
    <Layout>
      {isFetchedComponentData && (
        <Loading loading={loading}>
          <CheckInStep current={CheckInStepName.Confirmation} />
          {payments && (
            <ContentWrapper style={{ paddingTop: '1rem' }}>
              {payments.reservations?.map((reservation, index) => (
                <RoomBillDetail
                  key={index}
                  roomCss={index > 0 ? { marginTop: '1rem' } : {}}
                  reservation={reservation}
                  assignTimeSelectionSpaces={assignSpaces}
                />
              ))}

              <div css={spacerTopStyle}>
                <AmountBill totalAmount={totalAmount} totalTaxPrice={totalTax} />
              </div>

              <PaymentFormTemplate>
                <CheckInPaymentForm totalAmount={totalAmount} />
              </PaymentFormTemplate>
            </ContentWrapper>
          )}
        </Loading>
      )}
    </Layout>
  )
}
